Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setComponentProps = setComponentProps;
exports.updateComponentProps = updateComponentProps;
exports.removeComponentProps = removeComponentProps;

var _constants = require('../constants');

var _constants2 = require('../utils/constants');

var getfilteredOptions = function getfilteredOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filteredOptions = {};
  Object.keys(options).forEach(function (option) {
    if (_constants2.validProps.includes(option)) {
      filteredOptions[option] = options[option];
    }
  });
  return filteredOptions;
};

function setComponentProps(component, options) {
  return {
    type: _constants.SET_PROPS,
    component: component,
    options: getfilteredOptions(options)
  };
}

function updateComponentProps(component, options) {
  return {
    type: _constants.UPDATE_PROPS,
    component: component,
    options: getfilteredOptions(options)
  };
}

function removeComponentProps(component) {
  return {
    type: _constants.REMOVE_PROPS,
    component: component
  };
}